import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import { Backdrop, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { PostAdd } from '@material-ui/icons';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import DadosContaAPagar from './DadosContaAPagar';
import { saveAnexosContaAPagar, getLinkDocumentoDeCobranca, getLinkNotaFiscal, getLinkComprovante, selectValues, parseCurrencyToNumber, notifyExceedingBordero, notifyBordero, taskManager, sendEmailToNotify, getRegs } from '../../../utils/fc';
import DatePicker from 'react-datepicker';
import SearchableSelect from 'react-select'
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import { currencyFormatter } from '../../../utils/currencyFormatter';
import AddFilesNoForm from '../../../components/Template/Files/AddFilesNoForm';
import ModalFormAddFavBordero from '../../../components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero';
import ModalFormEdicaoFavBordero from '../../../components/Modals/ModalFormEdicaoFavBordero/ModalFormEdicaoFavBordero';
import { notifyError } from '../../../utils/notify';
import PdfPreviewPanel from './PdfPreviewPanel';

const ModalAddContaAPagar = ( props ) => {

    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [emptyValues, setEmptyValues] = useState([]);
    const [isPf, setIsPf] = useState(true);
    const [dataVenc, setDataVenc] = useState('')
    const [dataQuit, setDataQuit] = useState('')
    const [valor, setValor] = useState('0.00')
    const [desc, setDesc] = useState('')
    const [isLoadingCadastra, setIsLoadingCadastra] = useState(false);
    const [todasAsContas, setTodasAsContas] = useState([])
    const [todasAsCategorias, setTodasAsCategorias] = useState([])
    const [conta, setConta] = useState(null)
    const [categoria, setCategoria] = useState({})
    const [orcItems, setOrcItems] = useState([])
    const [selectedOrcItem, setSelectedOrcItem] = useState({}); // To store the selected option
    const [favs, setFavs] = useState([])
    const [favInfo, setFavInfo] = useState({})
    const [selectedFav, setSelectedFav] = useState({})
    const [orcamentoInfoMes, setOrcamentoInfoMes] = useState({})
    const [linkDocumentoDeCobranca, setLinkDocumentoDeCobranca] = useState(null);
    const [linkNotaFiscal, setLinkNotaFiscal] = useState(null);
    const [documentoDeCobrancaFiles, setDocumentoDeCobrancaFiles] = useState([]);
    const [notaFiscalFiles, setNotaFiscalFiles] = useState([]);
    const [codBarras, setCodBarras] = useState('');
    const [pagadores, setPagadores] = useState([]);
    const [pagador, setPagador] = useState({});
    const [dispNF, setDispNF] = useState(false);
    const [dispDocCobranca, setDispDocCobranca] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewLabel, setPreviewLabel] = useState('');


    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
      setOpen(false);
      setPreviewUrl(null);
      setPreviewLabel('');
    };

    const handleOpenErrorModal = () => setOpenErrorModal(true);
    const handleCloseErrorModal = () => {
      setOpenErrorModal(false);
      setEmptyValues([]);
    };

    /*
    const verifySaldo = async () => {

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        fields: {
          [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
          [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
        },
        data: {
          orcItem_id: selectedOrcItem.value,
          orcDot_data: moment(dataVenc).format('YYYY-MM'),
          orcDot_ativo: 1,
        }
      })}`;

      const checkSaldo = await oikosApi.get(queryString);

      console.log(checkSaldo)

      if (checkSaldo.data.length === 0) {
        console.log("Sem orcDot para este orcItem")
        return
      } else {
        if (!checkSaldo.data[0].emOrcDot) {
          checkSaldo.data[0].emOrcDot = 0;
        }
      }

      console.log(checkSaldo)
    }
    */
    const handleChangeCodBarras = (e) => {
      const inputValue = e.target.value;
      const digitsOnly = inputValue.replace(/\D/g, '');

      const length = digitsOnly.length;

      const startsWith = digitsOnly.substring(0, 3);

      const isBoleto = length === 47 && /^\d{3}9/.test(digitsOnly);  // Bank boleto
      const isConcessionaria = length === 48 && digitsOnly.startsWith('8');  // Utility or tax
      const isEAN = length === 13 || length === 14;  // Product barcodes

      const isCodigoDeBarras = isBoleto || isConcessionaria || isEAN;

      if (isCodigoDeBarras) {
        setCodBarras(String(digitsOnly));
      } else {
        setCodBarras(String(inputValue));
      }
    };

    const getFavs = async (pfTrue) => {
      try {
        if (!pfTrue) {
          const res = await selectValues('pj', 'pj_id', 'pj_nomefanta');

          const sortedFavs = (res).sort((a, b) => {
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
          })

          setFavs(sortedFavs);

        } else {
          const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');

          const sortedFavs = (res).sort((a, b) => {
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
          })

          setFavs(sortedFavs);

        }
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      }
    };

    const convertValueToText = (value) => {
      switch (value) {
        case 'bdro_dtVenc':
          return 'Data de Vencimento';
        case 'bdro_dtQuit':
          return 'Data de Quitação';
        case 'conta_id':
          return 'Conta';
        case 'orcItem_id':
            return 'Item orçamentário';
        case 'bdro_favId':
          return 'Favorecido';
        case 'bdro_desc':
          return 'Descrição';
        case 'categ_id':
          return 'Categoria';
        case 'documento de cobranca':
          return 'Documento de cobrança';
        case 'nota fiscal':
          return 'Nota Fiscal';
        case 'bdro_pagador':
          return 'Pagador';
        case 'bdro_codBarras':
          return 'Código de barras';
        case 'valor':
          return 'Valor';
        case 'dados bancários do favorecido':
          return 'Dados bancários do favorecido';
      }
    }

    function parseLocalDate(yyyyMmDd) {
      const [y, m, d] = yyyyMmDd.split("-").map(Number)
      return new Date(y, m - 1, d)
    }

    function startOfWeekMonday(date) {
      const d = new Date(date)
      d.setHours(0, 0, 0, 0)

      // JS: Sunday=0 ... Saturday=6
      const day = d.getDay()
      const diffToMonday = (day + 6) % 7 // Monday -> 0, Sunday -> 6

      d.setDate(d.getDate() - diffToMonday)
      return d
    }

    function isSameWeekAsToday(dateString) {
      const today = new Date()
      const target = parseLocalDate(dateString)

      return startOfWeekMonday(today).getTime() === startOfWeekMonday(target).getTime()
    }

    const cadastrarPendente = async () => {

      setIsStatusLoading(false);

      setIsLoadingCadastra(true);

      // Restrição: vencimento no mesmo dia — somente IDs autorizados
      const AUTHORIZED_SAME_DAY_IDS = [1, 2, 3, 31];
      const today = moment().format('YYYY-MM-DD');
      const selectedDate = moment(dataVenc).format('YYYY-MM-DD');
      if (dataVenc && selectedDate === today && !AUTHORIZED_SAME_DAY_IDS.includes(Number(props.user.pf_id))) {
        notifyError("Você não tem autorização para lançar itens no borderô com vencimento para hoje. Utilize uma data de vencimento a partir de amanhã.");
        setIsLoadingCadastra(false);
        return;
      }

      if (props.proj_orcRubrId) {
        const bdroBody = {
          action: 'insert',
          table: 'bdro',
          data: {
            bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
            bdro_vlr: Number(valor),
            bdro_usuarioCria: props.user.pf_id,
            bdro_usuarioMod: props.user.pf_id,
            bdro_favTab: isPf ? 'pf' : 'pj',
            bdro_favId: isPf ? selectedFav.value : selectedFav.value,
            orcItem_id: selectedOrcItem.value,
            bdro_desc: desc,
            bdro_orcPend: 1,
            bdro_codBarras: codBarras,
            bdro_dispNF: dispNF ? 1 : 0,
            bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
          },
        };

        const bdroCreated = await oikosApi.post('/', bdroBody);

        if ((documentoDeCobrancaFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
        if ((notaFiscalFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
      } else {
        const bdroBody = {
          action: 'insert',
          table: 'bdro',
          data: {
            bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
            bdro_dtQuit: ((moment(dataQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(dataQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(dataQuit).format('YYYY-MM-DD'),
            bdro_vlr: Number(valor),
            conta_id: conta.value,
            bdro_usuarioCria: props.user.pf_id,
            bdro_usuarioMod: props.user.pf_id,
            bdro_favTab: isPf ? 'pf' : 'pj',
            bdro_favId: isPf ? selectedFav.value : selectedFav.value,
            orcItem_id: selectedOrcItem.value,
            bdro_desc: desc,
            bdro_orcPend: 1,
            bdro_pagador: pagador?.value,
            bdro_codBarras: codBarras,
            bdro_dispNF: dispNF ? 1 : 0,
            bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
          },
        };

        const bdroCreated = await oikosApi.post('/', bdroBody);

        if ((documentoDeCobrancaFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
        if ((notaFiscalFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
      }

      sendEmailToNotify(
        selectedOrcItem.pf_emailProf,
        'Necessidade de suplementação orçamentária',
        `O borderô cadastrado com vencimento em ${moment(dataVenc).format('DD/MM/YYYY')} e valor de R$ ${currencyFormatter.format(Number(valor))} excedeu o orçamento disponível para o item orçamentário selecionado. Por favor, verifique a necessidade de suplementação orçamentária. Item orçamentário: ${selectedOrcItem.label}.`
      );

      setIsLoadingCadastra(false);

      props.preloading();

      handleClose()
      handleCloseModal()
    }

    const handleSelectChangePagador = (e) => {
      const selected = pagadores.find((pagador) => {if (pagador && e) return pagador.value === e.value});
      if (selected) {
        setPagador(selected); // Update with the full pj object
      }
    };

    const handleSubmit = async () => {
      // IDs autorizados a lançar itens com vencimento no mesmo dia
      const AUTHORIZED_SAME_DAY_IDS = [1, 2, 3, 31];

      if(dataVenc) {
        // Restrição existente: vencimento na semana corrente (para usuários sem perm_id 1)
        if (isSameWeekAsToday(moment(dataVenc).format('YYYY-MM-DD')) && props.user.perm_id !== 1) {
          notifyError("Impossível cadastrar compromisso com vencimento na semana corrente. Cadastre com data de vencimento a partir da semana que vem ou solicite ao seu gerente que realize o cadastro.");
          return;
        }

        // Nova restrição: vencimento no mesmo dia — somente IDs autorizados
        const today = moment().format('YYYY-MM-DD');
        const selectedDate = moment(dataVenc).format('YYYY-MM-DD');
        if (selectedDate === today && !AUTHORIZED_SAME_DAY_IDS.includes(Number(props.user.pf_id))) {
          notifyError("Você não tem autorização para lançar itens no borderô com vencimento para hoje. Utilize uma data de vencimento a partir de amanhã.");
          return;
        }
      }

      if(props.proj_orcRubrId) {
        const bdroBody = {
          action: 'insert',
          table: 'bdro',
          data: {
            bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
            bdro_vlr: Number(valor),
            bdro_usuarioCria: props.user.pf_id,
            bdro_usuarioMod: props.user.pf_id,
            bdro_favTab: isPf ? 'pf' : 'pj',
            bdro_favId: isPf ? selectedFav?.value : selectedFav?.value,
            orcItem_id: selectedOrcItem?.value,
            bdro_desc: desc,
            bdro_orcPend: 0,
            bdro_codBarras: codBarras,
            bdro_dispNF: dispNF ? 1 : 0,
            bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
          },
        };

        for (const key in bdroBody.data) {
          if (
            ((!bdroBody.data[key] && bdroBody.data[key] != 0) ||
            bdroBody.data[key] === 'Data inválida') &&
            key !== "bdro_codBarras" &&
            key !== "conta_id" &&
            key !== "bdro_pagador" &&
            key !== "bdro_orcPend"
          )
          {
            console.log(`${key} is falsy`);
            emptyValues.push(`${key}`);
            console.log(emptyValues)
          }
        }

        if (notaFiscalFiles.length <= 0 && !dispNF) {
          emptyValues.push(`nota fiscal`);
        }

        if (Number(valor) <= 0) {
        emptyValues.push(`valor`);
        }

        if (documentoDeCobrancaFiles.length <= 0 && !dispDocCobranca) {
          emptyValues.push(`documento de cobranca`);
        }

        if (!selectedFav.value) {
          emptyValues.push(`bdro_favId`);
        }

        if (Object.keys(categoria).length === 0) {
          console.log(`categoria is falsy`);
          emptyValues.push(`categ_id`);
        }

        if (dispDocCobranca) {
          if (isPf) {
            if ((!selectedFav.pf_contaBanco || selectedFav.pf_contaBanco === '') || (!selectedFav.pf_contaAgencia || selectedFav.pf_contaAgencia === '') || (!selectedFav.pf_contaNum || selectedFav.pf_contaNum === '')) {
              emptyValues.push(`dados bancários do favorecido`);
            }
          } else {
            if ((!selectedFav.pj_contaBanco || selectedFav.pj_contaBanco === '') || (!selectedFav.pj_contaAgencia || selectedFav.pj_contaAgencia === '') || (!selectedFav.pj_contaNum || selectedFav.pj_contaNum === '')) {
              emptyValues.push(`dados bancários do favorecido`);
            }
          }
        }

        if (emptyValues.length > 0) {
          handleOpenErrorModal();
          return;
        }

        const queryString = `/?${qs.stringify({
          action: 'get',
          table: 'orcDot',
          fields: {
            [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
            [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
          },
          data: {
            orcItem_id: selectedOrcItem.value,
            orcDot_data: moment(dataVenc).format('YYYY-MM'),
            orcDot_ativo: 1,
          }
        })}`;

        const checkSaldo = await oikosApi.get(queryString);

        console.log(checkSaldo)

        if(checkSaldo.data.length === 0) {

          const queryStringBdro = `/?${qs.stringify({
            action: 'get',
            table: 'bdro',
            fields: {
              [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
            },
            data: {
              orcItem_id: selectedOrcItem.value,
              bdro_dataVenc: moment(dataVenc).format('YYYY-MM'),
              bdro_ativo: 1,
            }
          })}`;

          const getBdroInfo = await oikosApi.get(queryStringBdro);
          setOrcamentoInfoMes(getBdroInfo.data[0]);

          handleOpenModal()
          return;
        }

        if ((checkSaldo.data.length > 0)) {
          setOrcamentoInfoMes(checkSaldo.data[0]);
          const tolerancia = -0.01;

          if ((checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero) <= tolerancia) {
            handleOpenModal()
            return;
          }
        }

        const bdroCreated = await oikosApi.post('/', bdroBody);

        if ((documentoDeCobrancaFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
        if ((notaFiscalFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
      } else {

        const bdroBody = {
          action: 'insert',
          table: 'bdro',
          data: {
            bdro_dtVenc: moment(dataVenc).format('YYYY-MM-DD'),
            bdro_dtQuit: ((moment(dataQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(dataQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(dataQuit).format('YYYY-MM-DD'),
            bdro_vlr: Number(valor),
            conta_id: conta?.value,
            bdro_usuarioCria: props.user.pf_id,
            bdro_usuarioMod: props.user.pf_id,
            bdro_favTab: isPf ? 'pf' : 'pj',
            bdro_favId: isPf ? selectedFav?.value : selectedFav?.value,
            orcItem_id: selectedOrcItem?.value,
            bdro_desc: desc,
            bdro_orcPend: 0,
            bdro_pagador: pagador?.value,
            bdro_codBarras: codBarras,
            bdro_dispNF: dispNF ? 1 : 0,
            bdro_dispDocCobranca: dispDocCobranca ? 1 : 0,
          },
        };

        for (const key in bdroBody.data) {
          if (
            ((!bdroBody.data[key] && bdroBody.data[key] != 0) ||
            bdroBody.data[key] === 'Data inválida') &&
            key !== "bdro_codBarras" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_dtQuit" &&
            key !== "bdro_orcPend" &&
            (props.user.perm_id === 1 && (!bdroBody.data[key]) && ((key === "bdro_pagador") || (key === "conta_id")))
          )
          {
            console.log(`${key} is falsy`);
            emptyValues.push(`${key}`);
            console.log(emptyValues)
          }
        }

        if (!selectedFav.value) {
          emptyValues.push(`bdro_favId`);
        }

        if (notaFiscalFiles.length <= 0 && !dispNF) {
          emptyValues.push(`nota fiscal`);
        }

        if (Number(valor) <= 0) {
        emptyValues.push(`valor`);
        }

        if (documentoDeCobrancaFiles.length <= 0 && !dispDocCobranca) {
          emptyValues.push(`documento de cobranca`);
        }

        if (Object.keys(categoria).length === 0) {
          console.log(`categoria is falsy`);
          emptyValues.push(`categ_id`);
        }

        if (emptyValues.length > 0) {
          handleOpenErrorModal();
          return;
        }

        const queryString = `/?${qs.stringify({
          action: 'get',
          table: 'orcDot',
          fields: {
            [`(SELECT SUM(orcDot_valor) FROM orcDot WHERE orcItem_id = ${selectedOrcItem.value} AND orcDot_ativo = 1 AND DATE_FORMAT(orcDot_data, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "emOrcDot",
            [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
          },
          data: {
            orcItem_id: selectedOrcItem.value,
            orcDot_data: moment(dataVenc).format('YYYY-MM'),
            orcDot_ativo: 1,
          }
        })}`;

        const checkSaldo = await oikosApi.get(queryString);

        console.log(checkSaldo)

        if(checkSaldo.data.length === 0) {

          const queryStringBdro = `/?${qs.stringify({
            action: 'get',
            table: 'bdro',
            fields: {
              [`(SELECT SUM(bdro_vlr) FROM bdro WHERE orcItem_id = ${selectedOrcItem.value} AND bdro_ativo = 1 AND DATE_FORMAT(bdro_dtVenc, '%Y-%m') = '${moment(dataVenc).format('YYYY-MM')}')`]: "jaNoBordero",
            },
            data: {
              orcItem_id: selectedOrcItem.value,
              bdro_dataVenc: moment(dataVenc).format('YYYY-MM'),
              bdro_ativo: 1,
            }
          })}`;

          const getBdroInfo = await oikosApi.get(queryStringBdro);
          setOrcamentoInfoMes(getBdroInfo.data[0]);

          handleOpenModal()
          return;
        }

        if ((checkSaldo.data.length > 0)) {
          setOrcamentoInfoMes(checkSaldo.data[0]);
          const tolerancia = -0.01;

          if ((checkSaldo.data[0].emOrcDot - Number(valor) - checkSaldo.data[0].jaNoBordero) <= tolerancia) {
            handleOpenModal();
            return;
          }
        }

        const bdroCreated = await oikosApi.post('/', bdroBody);

        if ((documentoDeCobrancaFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'documento de cobranca', arquivo: documentoDeCobrancaFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
        if ((notaFiscalFiles.length > 0)) {
          const arrayAnexos = [
            { tipo: 'nota fiscal', arquivo: notaFiscalFiles[0].data },
          ]
          console.log(arrayAnexos);
          const arrayAnexosFiltrado = arrayAnexos.filter(item => item.arquivo);
          console.log(arrayAnexosFiltrado);
          console.log(bdroCreated.data[0]);
          await saveAnexosContaAPagar(arrayAnexosFiltrado, bdroCreated.data[0]);
        }
      }

      props.preloading();

      handleClose();
      return;

    };

    const preloading = async (isPfValue) => {
      const table = isPfValue ? 'pf' : 'pj';
      const value = isPfValue ? 'pf_id' : 'pj_id';
      const label = isPfValue ? 'pf_nomeExibicao' : 'pj_nomefanta';

      const res = await selectValues(table, value, label, {},
        {
          ...(isPfValue ? {pf_contaBanco: "pf_contaBanco"} : {pj_contaBanco: "pj_contaBanco"}),
          ...(isPfValue ? {pf_contaAgencia: "pf_contaAgencia"} : {pj_contaAgencia: "pj_contaAgencia"}),
          ...(isPfValue ? {pf_contaNum: "pf_contaNum"} : {pj_contaNum: "pj_contaNum"}),
        }
      );

      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setFavs(sortedFavs);

      let dataCategorias = {
        categ_ativo: 1,
      }

      if (props.proj_orcRubrId) {
        const in_txt = `!IN!(SELECT categ_id FROM viewRubr_OrcItem WHERE nivel3_id = ${props.proj_orcRubrId})`;
        dataCategorias = {
          categ_ativo: 1,
          categ_id: in_txt
        }
      }

      const resTodasAsCategorias = await selectValues('categ', 'categ_id', 'categ_nome', dataCategorias);

      const sortedTodasAsCategorias = (resTodasAsCategorias).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setTodasAsCategorias(sortedTodasAsCategorias);

      const resTodasAsContas = await selectValues('conta', 'conta_id', 'conta_nome', {contaTp_id: 1});

      const sortedTodasAsContas = (resTodasAsContas).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setTodasAsContas(sortedTodasAsContas);

      getPagadores();

    };

    const handleSelectChangeOrcItem = (e) => {
      const selected = orcItems.find((orcamentoItem) => {if(e) return orcamentoItem.value === e.value});
      if (selected) {
        setSelectedOrcItem(selected); // Update with the full pj object
      }
    };

    const handleSelectConta = (e) => {
      const selected = todasAsContas.find((conta) => {if(e) return conta.value === e.value});
      if (selected) {
        setConta(selected); // Update with the full pj object
      }
    };

    const handleSelectCategoria = (e) => {

      const selected = todasAsCategorias.find((categ) => {if(e) return categ.value === e.value});

      if (selected) {
        setCategoria(selected); // Update with the full pj object
        getOrcItems(selected.value);
      }

      setSelectedOrcItem({});
    };

    const handleSelectChangeFav = async (e) => {
      if(isPf) {

        const selected = favs.find((pf) => {if(e) return pf.value === e.value});

        if (selected) {
          setSelectedFav(selected); // Update with the full pj object
          const res = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'pf',
            fields: {},
            data: { pf_id: selected.value }
          })}`);

          setFavInfo(res.data[0])
        }
      } else {

        const selected = favs.find((pj) => {if(e) return pj.value === e.value});

        if (selected) {
          setSelectedFav(selected); // Update with the full pj object
          const res = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'pj',
            fields: {},
            data: { pj_id: selected.value }
          })}`);

          setFavInfo(res.data[0])
        }
      }
    };

    const getOrcItems = async (categ_id) => {
      let dataOrcItems = {
        orcItem_ativo: 1,
        categ_id: categ_id,
      }

      if (props.proj_orcRubrId) {
        const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${props.proj_orcRubrId}))`;
        dataOrcItems = {
          orcItem_ativo: 1,
          orcItem_id: in_txt,
          categ_id: categ_id,
        }
      }

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'orcItem',
        fields: {
          orcItem_id: 'value',
          "(CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = orcItem.orcRubr_id),'::',orcItem_desc))": 'label',
          "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = orcItem.pf_id)": 'pf_emailProf',
        },
        data: dataOrcItems,
        order: 'label'
      })}`;

      const resp = await oikosApi.get(queryString);

      const parsedArray = resp.data.map((caminho) => {
        return { value: caminho.value, label: caminho.label, pf_emailProf: caminho.pf_emailProf }
      },[])

      setOrcItems(parsedArray);
    }

    const getPagadores = async () => {

      const resPagador1 = await selectValues('pj', 'pj_id', 'pj_nomefanta', {pj_id: 1});
      const resPagador2 = await selectValues('pj', 'pj_id', 'pj_nomefanta', {pj_id: 2});

      const resPagadores = [...resPagador1, ...resPagador2]

      console.log(resPagadores)

      setPagadores(resPagadores);
    };

    useEffect(() => {
      preloading(isPf);
    }, [isPf])

    return (
      <>
        {console.log(props)}
        <Button style={{backgroundColor: "rgba(51, 153, 51, 0.92)", color: "white"}} variant="" onClick={async () => {
          handleClickOpen();
          }}>
          <PostAdd />
        </Button>
        <Dialog
          fullWidth
          maxWidth={false}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              margin: 'auto',
              width: '1200px',
              maxWidth: '96vw',
              maxHeight: '92vh',
            },
            component: 'form',
            onSubmit: async (event) => {
                setIsStatusLoading(true);
                event.preventDefault();
                await handleSubmit();
                setIsStatusLoading(false);
            },
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle sx={{ py: 1.25, px: 2.5, borderBottom: '1px solid #e5e7eb' }}>
            <Typography component="span" sx={{ fontWeight: 700, fontSize: 16 }}>
              Nova conta a pagar
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ p: 2, overflow: 'hidden' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1.05fr 0.95fr',
                gap: 16,
                minHeight: 540,
                maxHeight: 'calc(92vh - 160px)',
              }}
            >
              <div style={{ overflowY: 'auto', paddingRight: 4 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1, color: '#0f172a' }}>
                  Dados da conta
                </Typography>

                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label="Descrição"
                  size="small"
                  margin="dense"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />

                <div className="d-flex flex-row" style={{ gap: 10, marginTop: 4 }}>
                  <FormControl size="small" style={{ flex: 1 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Valor</InputLabel>
                    <MaskedInput
                      mask="R$ num"
                      unmask
                      inputRef={(el) => { const inputVlrGlobal = el }}
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 1000000000,
                        },
                      }}
                      lazy={false}
                      value={valor}
                      onAccept={(value) => setValor(value)}
                    />
                  </FormControl>
                  {props.user.perm_id === 1 && (
                    <FormControl size="small" style={{ flex: 1.2 }}>
                      <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Conta</InputLabel>
                      <SearchableSelect
                        classNamePrefix="select2-selection"
                        placeholder="Selecionar..."
                        isClearable
                        isSearchable
                        options={todasAsContas}
                        onChange={handleSelectConta}
                        value={conta}
                        styles={{
                              control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                              valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                              indicatorsContainer: (base) => ({ ...base, height: 32 }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              menu: (base) => ({ ...base, zIndex: 5 }),
                            }}
                      />
                    </FormControl>
                  )}
                  <FormControl size="small" style={{ flex: 1.2 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Categoria</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isClearable
                      isSearchable
                      options={todasAsCategorias}
                      onChange={handleSelectCategoria}
                      value={categoria}
                      styles={{
                              control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                              valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                              indicatorsContainer: (base) => ({ ...base, height: 32 }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              menu: (base) => ({ ...base, zIndex: 5 }),
                            }}
                    />
                  </FormControl>
                </div>

                {orcItems && (
                  <FormControl fullWidth size="small" style={{ marginTop: 8 }}>
                    <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Item orçamentário</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isClearable
                      isSearchable
                      options={orcItems}
                      onChange={handleSelectChangeOrcItem}
                      value={selectedOrcItem}
                      styles={{
                              control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                              valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                              indicatorsContainer: (base) => ({ ...base, height: 32 }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              menu: (base) => ({ ...base, zIndex: 5 }),
                            }}
                    />
                  </FormControl>
                )}

                <div className="d-flex flex-row align-items-end" style={{ gap: 10, marginTop: 8 }}>
                  <div style={{ flex: 1 }}>
                    <Label className="mb-1" style={{ fontSize: 12 }}>Vencimento</Label>
                    <DatePicker
                      placeholderText="__/__/_____"
                      locale="pt-BR"
                      className="form-control form-control-sm"
                      dateFormat="dd/MM/yyyy"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      selected={dataVenc}
                      dropdownMode="select"
                      onChange={(date) => setDataVenc(date)}
                    />
                  </div>
                  {props.user.perm_id === 1 && (
                    <>
                      <div style={{ flex: 1 }}>
                        <Label className="mb-1" style={{ fontSize: 12 }}>Quitação</Label>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control form-control-sm"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          selected={dataQuit}
                          dropdownMode="select"
                          onChange={(date) => setDataQuit(date)}
                        />
                      </div>
                      <div style={{ flex: 1.3 }}>
                        <Label className="mb-1" style={{ fontSize: 12 }}>Pagador</Label>
                        <SearchableSelect
                          classNamePrefix="select"
                          placeholder="Selecionar..."
                          isClearable
                          isSearchable
                          options={pagadores}
                          onChange={handleSelectChangePagador}
                          value={pagador}
                          styles={{
                              control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                              valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                              indicatorsContainer: (base) => ({ ...base, height: 32 }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              menu: (base) => ({ ...base, zIndex: 5 }),
                            }}
                        />
                      </div>
                    </>
                  )}
                </div>

                <FormControl fullWidth size="small" style={{ marginTop: 8 }}>
                  <InputLabel shrink sx={{ backgroundColor: 'white', px: 0.5 }}>Código de barras</InputLabel>
                  <Input
                    type="text"
                    bsSize="sm"
                    value={String(codBarras)}
                    onChange={(e) => handleChangeCodBarras(e)}
                  />
                </FormControl>

                <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 14, marginBottom: 4 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#0f172a' }}>
                    Favorecido
                  </Typography>
                  <div className="d-flex align-items-center" style={{ gap: 4 }}>
                    <ModalFormAddFavBordero isPf={isPf} preloading={props.preloading} getFavs={getFavs} setSelectedFav={setSelectedFav} setFavInfo={setFavInfo}/>
                    {(Object.keys(selectedFav).length > 0) && (
                      <ModalFormEdicaoFavBordero
                        isPf={isPf}
                        getFavs={getFavs}
                        preloading={props.preloading}
                        fav={selectedFav}
                        setSelectedFav={setSelectedFav}
                        setFavInfo={setFavInfo}
                        onFavSaved={async (favId) => {
                          const fresh = isPf
                            ? await getRegs('pf', { pf_id: favId })
                            : await getRegs('pj', { pj_id: favId })
                          setFavInfo((Array.isArray(fresh) && fresh[0]) || {})
                          const list = await getFavs(isPf)
                          const found = (list || []).find((f) => f.value === favId)
                          if (found) setSelectedFav(found)
                        }}
                      />
                    )}
                  </div>
                </div>

                <FormControl size="small">
                  <RadioGroup
                    row
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setIsPf(JSON.parse(e.target.value));
                      setSelectedFav({});
                      setFavInfo({});
                    }}
                  >
                    <FormControlLabel control={<Radio size="small" value="true" />} label="PF" checked={isPf === true} />
                    <FormControlLabel control={<Radio size="small" value="false" />} label="PJ" checked={isPf === false} />
                  </RadioGroup>
                </FormControl>

                <FormControl fullWidth size="small" style={{ marginTop: 4 }}>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar favorecido..."
                    isClearable
                    isSearchable
                    options={favs}
                    onChange={handleSelectChangeFav}
                    value={selectedFav}
                    styles={{
                              control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: 13 }),
                              valueContainer: (base) => ({ ...base, padding: '0 6px', height: 32 }),
                              indicatorsContainer: (base) => ({ ...base, height: 32 }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              menu: (base) => ({ ...base, zIndex: 5 }),
                            }}
                  />
                </FormControl>

                {(Object.keys(favInfo).length === 0) ? (
                  <p style={{ fontSize: 12, marginTop: 8, color: '#64748b' }}>Sem informações sobre o favorecido.</p>
                ) : isPf ? (
                  <div style={{ fontSize: 12, marginTop: 8, lineHeight: 1.55 }}>
                    <div>CPF: <strong>{favInfo.pf_cpf}</strong></div>
                    <div style={{ marginTop: 6, fontWeight: 600 }}>Dados bancários</div>
                    <div>Titular: <strong>{favInfo.pf_contaTitNome}</strong></div>
                    <div>Doc titular: <strong>{favInfo.pf_contaTitDoc}</strong></div>
                    <div>Banco: <strong>{favInfo.pf_contaBanco}</strong></div>
                    <div>Agência: <strong>{favInfo.pf_contaAgencia}</strong></div>
                    <div>Número: <strong>{favInfo.pf_contaNum}</strong></div>
                    <div>Pix: <strong>{favInfo.pf_chavePix}</strong></div>
                    <div>Tipo: <strong>{favInfo.pf_contaTp}</strong></div>
                  </div>
                ) : (
                  <div style={{ fontSize: 12, marginTop: 8, lineHeight: 1.55 }}>
                    <div>CNPJ: <strong>{favInfo.pj_cnpj}</strong></div>
                    <div style={{ marginTop: 6, fontWeight: 600 }}>Dados bancários</div>
                    <div>Titular: <strong>{favInfo.pj_contaTitNome}</strong></div>
                    <div>Doc titular: <strong>{favInfo.pj_contaTitDoc}</strong></div>
                    <div>Banco: <strong>{favInfo.pj_contaBanco}</strong></div>
                    <div>Agência: <strong>{favInfo.pj_contaAgencia}</strong></div>
                    <div>Número: <strong>{favInfo.pj_contaNum}</strong></div>
                    <div>Pix: <strong>{favInfo.pj_chavePix}</strong></div>
                    <div>Tipo: <strong>{favInfo.pj_contaTp}</strong></div>
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, gap: 8 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#0f172a' }}>
                  Anexos
                </Typography>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {[
                    {
                      key: 'cob',
                      title: 'Cobrança',
                      icon: 'ri-receipt-line',
                      files: documentoDeCobrancaFiles,
                      setFiles: setDocumentoDeCobrancaFiles,
                      disp: dispDocCobranca,
                      setDisp: setDispDocCobranca,
                    },
                    {
                      key: 'nf',
                      title: 'Nota fiscal',
                      icon: 'ri-file-text-line',
                      files: notaFiscalFiles,
                      setFiles: setNotaFiscalFiles,
                      disp: dispNF,
                      setDisp: setDispNF,
                    },
                  ].map((slot) => {
                    const url = slot.files?.[0]?.props?.preview || null
                    const active = previewUrl && url && previewUrl === url
                    return (
                      <div
                        key={slot.key}
                        style={{
                          border: active ? '1px solid #0f766e' : '1px solid #e2e8f0',
                          borderRadius: 8,
                          padding: 8,
                          background: active ? '#f0fdfa' : '#fff',
                          minHeight: 120,
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <span style={{ fontSize: 11, fontWeight: 700 }}>
                            <i className={`${slot.icon} mr-1`} />
                            {slot.title}
                          </span>
                          {url && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0"
                              style={{ fontSize: 11 }}
                              onClick={() => {
                                setPreviewUrl(url)
                                setPreviewLabel(slot.title)
                              }}
                            >
                              Ver
                            </button>
                          )}
                        </div>
                        <AddFilesNoForm
                          multiple={false}
                          accept={['.pdf']}
                          files={slot.files}
                          onFilesChange={(files) => {
                            slot.setFiles(files)
                            const next = files?.[0]?.props?.preview
                            if (next) {
                              setPreviewUrl(next)
                              setPreviewLabel(slot.title)
                            }
                          }}
                        />
                        <label style={{ fontSize: 11, marginTop: 4, marginBottom: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                          <input
                            type="checkbox"
                            checked={!!slot.disp}
                            onChange={(e) => slot.setDisp(e.target.checked)}
                          />
                          Dispensar
                        </label>
                      </div>
                    )
                  })}
                </div>

                <PdfPreviewPanel
                  url={previewUrl}
                  label={previewLabel}
                  onClose={() => { setPreviewUrl(null); setPreviewLabel('') }}
                />
              </div>
            </div>
          </DialogContent>

          <DialogActions sx={{ px: 2.5, py: 1.5, borderTop: '1px solid #e5e7eb' }}>
            {isStatusLoading && (
              <Button type="submit" variant="outlined" disabled endIcon={<Spinner/>}>
                Aguarde
              </Button>
            )}
            {!isStatusLoading && (
              <div className="d-flex justify-content-start" style={{ gap: 8 }}>
                <Button className="text-success" type="submit">Enviar</Button>
                <Button onClick={(e) => { e.preventDefault(); handleClose() }}>Cancelar</Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 500,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Orçamento excedido
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Valor solicitado: {currencyFormatter.format(valor)}<br/>
              Valor já solicitado com este item: {currencyFormatter.format(orcamentoInfoMes.jaNoBordero)}<br/>
              Saldo da solicitação: {currencyFormatter.format((Number(orcamentoInfoMes.emOrcDot) - (Number(orcamentoInfoMes.jaNoBordero) + Number(valor))))}<br/>
              Solicite ao seu gerente para avaliar suplementação orçamentária.
            </Typography>
            <Button onClick={handleCloseModal}>Ajustar</Button>
            {!isLoadingCadastra &&
            <Button onClick={cadastrarPendente}>Cadastrar mesmo assim</Button>
            }
            {isLoadingCadastra &&
              <Button
                autoFocus
                margin="dense"
                id="entregaRevInterna"
                name="entrega_rev_interna"
                label="Entrega a Revisao Interna"
                type="submit"
                variant="outlined"
                disabled
                endIcon={<Spinner/>}
              >Aguarde</Button>
            }
          </Box>
        </Modal>

        <Modal
          open={openErrorModal}
          onClose={handleCloseErrorModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 500,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Favor preencher todos os campos
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <p>Campos vazios:</p>
              {emptyValues.map((value, index) =>
                (
                  <div key={index}>
                    <span>{convertValueToText(value)}</span>
                  </div>
                )
              )}
            </Typography>
            <Button onClick={handleCloseErrorModal}>Voltar</Button>
          </Box>
        </Modal>
      </>
    )
}

export default ModalAddContaAPagar;
